import { CurrencyEnum } from '../enum/currency.enum';

export class Currency {

    static prefix(currency: string): string {
        switch (currency) {
            case CurrencyEnum.EUR:
                return '€';
            case CurrencyEnum.GBP:
                return '£';
            default:
                return '$';
        }
    }

    static suffix(currency: string): string {
        return '';
    }

    static normalize(currency: string, amount: number | string): string {
        return Number(amount).toFixed(2);
    }

    static render(amount: number, currency: string): string {
        return amount < 0 ? '-' : '' + this.prefix(currency) + Number(Math.abs(amount)).toFixed(2);
    }

}
